"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const select_1 = __importDefault(require("@kyruus/select"));
const utils_1 = require("./utils");
const read_only_1 = __importDefault(require("../../read-only"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const styles_1 = require("../../../styles");
const constants_1 = require("../../../constants");
const MAX_HEIGHT = 250;
/**
 * Wrapper that allows Select component to be used within Fields components
 */
function SelectInput(props) {
    const { type, mode, path, multiSelect, useTypeahead, creatable, virtualized = true, disabled = false, items: itemsFromProps, validator: validatorFromProps, isReadOnly } = props;
    const [state, actions] = (0, use_form_1.default)(path, {
        type,
        eventProcessor: utils_1.getSerializedValue,
        validator: validatorFromProps
    });
    const { AddOn } = state;
    if (!state.config.isVisible)
        return null;
    const items = itemsFromProps || state.config.items;
    if (state.config.isReadOnly || isReadOnly) {
        return react_1.default.createElement(read_only_1.default, { msg: (0, utils_1.getReadOnlyValue)(state.value, items) });
    }
    const initialSelection = multiSelect
        ? {
            initialSelectedItems: (0, utils_1.getDisplayValue)((0, utils_1.getSerializedValue)(state.value), items)
        }
        : {
            initialSelectedItem: (0, utils_1.getDisplayValue)((0, utils_1.getSerializedValue)(state.value), items)
        };
    const onClear = state.config.isClearable
        ? (clearSelection) => {
            clearSelection();
        }
        : null;
    // workaround FieldFocusWrapper props TS error
    const fieldFocusWrapperProps = { hasError: !!state.errors.length };
    const errorSectionId = `${state.config.path}-errors`;
    const labelId = `${state.config.path}-label`;
    const inputProps = {};
    if (useTypeahead) {
        inputProps['aria-labelledby'] = labelId;
        inputProps['aria-required'] = state.config.isRequired;
        inputProps['aria-invalid'] = state.errors.length > 0;
        inputProps['aria-describedby'] = errorSectionId;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.FieldFocusWrapper, Object.assign({}, fieldFocusWrapperProps),
            react_1.default.createElement("div", { className: "field-error-wrapper", "data-testid": `${path}-select-wrapper` },
                react_1.default.createElement(select_1.default, Object.assign({ id: path, errors: state.errors, disabled: disabled, useTypeahead: useTypeahead, creatable: creatable, mode: mode, multiSelect: multiSelect, items: items, onChange: actions.onChange, onClear: onClear, onInputValueChange: (value, status) => {
                        if (!status.isOpen) {
                            // takes care of "blur" when tabbing
                            actions.onBlur(value);
                        }
                        else {
                            actions.onChange(value);
                        }
                    }, placeholder: state.config.placeholder, icon: "ArrowDown", showItemsOnClick: true, itemToString: utils_1.labelFromItem, onOuterClick: () => {
                        actions.onBlur(state.value);
                    }, maxHeight: MAX_HEIGHT, virtualized: virtualized, "data-testid": path, inputProps: inputProps, listboxProps: {
                        'aria-required': state.config.isRequired,
                        'aria-labelledby': labelId,
                        'aria-invalid': state.errors.length > 0,
                        'aria-describedby': errorSectionId
                    } }, initialSelection)))),
        react_1.default.createElement(AddOn, null)));
}
SelectInput.defaultProps = {
    mode: 'dropdown',
    useTypeahead: false,
    multiSelect: false,
    creatable: false,
    type: constants_1.FIELD_TYPE_NAMES.SELECT
};
exports.default = SelectInput;
exports.defaultConfig = {};
//# sourceMappingURL=index.js.map